var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { requestGetEmployers, requestGetPlatforms } from '../clients/hub-api';
import { getHubEnvironment } from '../clients/hub-api/utils';
import PRIORITZED_PLATFORMS from '../consts/prioritized-platforms';
import PRIORITIZED_WORKDAY_EMPLOYERS from '../consts/prioritized-workday-employers';
import { getLinkTokenPayload, tokenHasJob } from './link-token';
import { mapEmployerToResult, mapPlatformToResult, } from './map-entity-to-search-result';
/**
 * Sorts values with prioritized values in order in the front
 * of the array.
 *
 * @param allValues - The values to be sorted
 * @param priorities - The list of values to sort by
 * @param getter - Extracts value to compare by
 * @returns T[] - A sorted array
 */
function prioritizeBy(allValues, priorities, getter) {
    var set = new Set(priorities);
    var result = [];
    priorities.forEach(function (p) {
        var val = allValues.find(function (v) { return getter(v) === p; });
        if (val)
            result.push(val);
    });
    return result.concat(allValues.filter(function (v) { return !set.has(getter(v)); }));
}
/**
 * Returns a thunked `prioritizeBy` function
 *
 * @param priorities - The list of values to sort by
 * @param getter - Extracts value to compare by
 * @returns - Thunked `prioritizeBy` function
 */
function getPrioritizeByFn(priorities, getter) {
    return function (allValues) { return prioritizeBy(allValues, priorities, getter); };
}
export var shouldIncludeWorkday = function (linkToken) {
    return !tokenHasJob(getLinkTokenPayload(linkToken), 'card_switch');
};
export var getLoadAllPlatformsWithWorkdayFn = function (mode, linkToken, featureFlags, platformType) {
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var prioritizeByKeys, _results, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    prioritizeByKeys = getPrioritizeByFn(PRIORITZED_PLATFORMS, function (x) { return x.key; });
                    if (!(getHubEnvironment() === 'staging' &&
                        (process.env.IS_CI || process.env.UI_TEST_MODE === 'record'))) return [3 /*break*/, 1];
                    _a = [];
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, requestGetPlatforms(mode, linkToken, platformType)];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3:
                    _results = _a;
                    return [2 /*return*/, prioritizeByKeys(_results).map(mapPlatformToResult)];
            }
        });
    }); };
};
export var getLoadWorkdayEmployersFn = function (mode, linkToken) { return function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
    var prioritizeByIds, _results;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                prioritizeByIds = getPrioritizeByFn(PRIORITIZED_WORKDAY_EMPLOYERS, function (x) { return x.id; });
                return [4 /*yield*/, requestGetEmployers(mode, linkToken, ['workday'], searchText)];
            case 1:
                _results = _a.sent();
                return [2 /*return*/, prioritizeByIds(_results).map(mapEmployerToResult)];
        }
    });
}); }; };
